import { GameOptions } from './../config/index';
export var getLeaderboardGameOptions = function () {
    return [GameOptions.PRIMARY, GameOptions.SECONDARY, GameOptions.SCRATCH];
};
